import React from 'react'
import logo from 'images/logos/brand/default.svg'
import Link from '../Link'
import NavbarWrapper from './Navbar.style'

const Navbar = () => (
  <NavbarWrapper>
    <div className='navbar-primary d-flex  align-items-center'>
      <div className='nav-links-container d-flex flex-row'>
        <div className='navbar-brand'>
          <Link to='/'>
            <img src={logo} alt='Home' />
          </Link>
        </div>
      </div>
    </div>
  </NavbarWrapper>
)

export default Navbar
